import { confirm } from "lib/@dialogs/confirm"
import {
    AUTHORING_RECOMMENDATION_STATE_APPLIED,
    AUTHORING_RECOMMENDATION_STATE_CONFLICTED,
    canApplyAuthoringRecommendationState,
    getAuthoringRecommendationState,
} from "./authoring-schedule-recommendations"

const CONFIRM_TITLE = "Text has changed"
const CONFIRM_MESSAGE =
    "The text in the editor has changed since this recommendation was created. Applying it will replace your current text with the recommended wording. Do you want to continue?"

export async function confirmApplyDriftedAuthoringRecommendation() {
    return confirm(CONFIRM_MESSAGE, CONFIRM_TITLE)
}

/**
 * @returns {Promise<{ proceed: boolean, force: boolean }>}
 */
export async function confirmApplyAuthoringRecommendationIfDrifted({ recommendation, draft }) {
    const state = getAuthoringRecommendationState({ recommendation, draft })

    if (state === AUTHORING_RECOMMENDATION_STATE_APPLIED) {
        return { proceed: false, force: false }
    }

    if (!canApplyAuthoringRecommendationState(state)) {
        return { proceed: false, force: false }
    }

    if (state === AUTHORING_RECOMMENDATION_STATE_CONFLICTED) {
        const confirmed = await confirmApplyDriftedAuthoringRecommendation()
        return { proceed: confirmed, force: confirmed }
    }

    return { proceed: true, force: false }
}
